export default [
  {
    path: "/manage-products",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/manage-products",
        name: "manage-products",
        component: () => import("./ManageProductsAndServicesCatalogue.vue"),
      },
    ],
  },
];
